export const HANDLE_NEXT = 'HANDLE_NEXT';
export const HANDLE_BACK = 'HANDLE_BACK';
export const HANDLE_RESET = 'HANDLE_RESET';

export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
